import _ from 'lodash';

import { getCookie } from '../../../helpers/helpers';
import {
    getCountryCode,
    isImpersonating
} from '../../../lendingAPI/lendingAPISelector';

export const isNewOffersEnabled = (state: any) => {
    if (getCookie('offers_endpoint_feature') === 'true') return true;
    if (getCountryCode(state) !== 'uk') return false;
    if (
        _.get(state, 'lendingAPI.context.data.is_new_offers_flow_enabled') ===
        true
    ) {
        return true;
    }

    return false;
};

export const isPartnerCustomer = (state: any) => {
    const customerType = _.get(state, 'lendingAPI.profile.data.user_type', '');
    const isPartnerCustomer =
        customerType === 'introducer_customer' && !isImpersonating(state);

    return isPartnerCustomer;
};

export function isBlockedOffer(offer: any) {
    return (
        offer.offer_type === 'sample' &&
        !offer.data_requirements.find(function (docRequirements: any) {
            return docRequirements.category === 'documents';
        })
    );
}
